// extracted by mini-css-extract-plugin
module.exports = {"label":"input_label__3Twew","input":"input_input__lG932","inputWithoutLabel":"input_inputWithoutLabel__f9CeH"};